import configService from './app-config.service';

const mapLocation = async (authToken, searchString) => {
    try {
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${authToken}`);

        const options = {
            method: 'GET',
            headers: headers
        };

        searchString = searchString.replace('/', '');
        const response = await fetch(`${configService.appConfig.apiUrl}/Search/Match/${searchString}`, options);

        if (!response.ok) {
            const message = `An error occurred: ${response.statusText}`;
            console.error(message);
            return;
        }

        const jsonData = await response.json();
        return jsonData;
    } catch (err) {
        return undefined;
    }
};

const fuzzy = async (authToken, searchString) => {
    try {
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${authToken}`);

        const options = {
            method: 'GET',
            headers: headers
        };

        searchString = searchString.replace('/', '');
        const response = await fetch(`${configService.appConfig.apiUrl}/Search/Fuzzy/${searchString}`, options);

        if (!response.ok) {
            const message = `An error occurred: ${response.statusText}`;
            console.error(message);
            return;
        }

        const jsonData = await response.json();
        return jsonData;
    } catch (err) {
        return undefined;
    }
};

const SearchService = {
    mapLocation,
    fuzzy
};

export default SearchService;
